module.exports = __webpack_public_path__ + "img/illustration-10-raw.eaee7e7e.png";